import ImagesScrollbarGallery from "@components/ImagesScrollbarGallery";
import cx from "classnames";
import styles from "./Intro.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { dinningPage } from "@utils/helper";
import _ from "lodash";
export default function Intro() {
  const { pageData } = usePageContext();
  const sliderSection = dinningPage.formatSliderSection(pageData);
  const slider = _.get(sliderSection, "slider", {});
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.overview)}>
        {_.get(sliderSection, "title", "")}
      </div>
      <ImagesScrollbarGallery
        galleryName={"dinningOverview"}
        isAuto={_.get(slider, "isAuto")}
        interval={_.get(slider, "interval")}
        images={_.get(slider, "slides", [])}
      />
    </div>
  );
}
